import { firstValueFrom, Observable, of } from "rxjs";
import { catchError, defaultIfEmpty, take } from "rxjs/operators";

export async function safeFirstValueFrom<T>(
  obs: Observable<T>,
): Promise<T | null> {
  try {
    const res = await firstValueFrom(
      obs.pipe(
        take(1),
        defaultIfEmpty(null),
        catchError((err) => {
          if (err.name === "EmptyError") return of(null);
          throw err;
        }),
      ),
    );
    return res;
  } catch (err) {
    throw err;
  }
}
